module.exports = __webpack_public_path__ + "img/bfa.9a958401.svg";